import React from "react";
const TimelineSection = () => <section>hey i'm TimelineSection</section>;
export default TimelineSection;
